import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'et-atoms-journal-back-btn',
  templateUrl: './et-journal-back-btn.component.html',
  styleUrls: ['./et-journal-back-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EtJournalBackBtnComponent {}
